module.exports = __webpack_public_path__ + "assets/images/et-feature@3x-905ef9a66a0ef81e52c68c3c40055675.png";